import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import Input from "../../../shared/items/contols/input";
import Icon from "../../../shared/items/static/icon";

class WinterMaintenceSearchTools extends Component {
  handleChangeStore(e, value) {
    const { onSearchTermWinterUnit } = this.props;
    onSearchTermWinterUnit(value);
  }

  render() {
    return (
      <div>
        <div className={styles.searchWinterUnit}>
          <Input name="searchTerm" type="text" handleChangeStore={this.handleChangeStore.bind(this)} placeholder="Поиск по рег. номеру (мин 4 символа)" />
          <div className={styles.container_searchBtn}>
            <Icon name="search" />
          </div>
        </div>
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceSearchTools));
